import { useState } from "react";
import RefreshButton from "./RefreshButton.js";

function GlobleRefreshButton() {
    const [isRefreshing, setIsRefreshing] = useState(false);

    const handleRefresh = () => {
        if (isRefreshing) return;
        setIsRefreshing(true);

        if (typeof window !== 'undefined') {
            window.location.reload();
        }
    };

    return <RefreshButton onClick={handleRefresh} text={true} loading={isRefreshing} />;
}

export default GlobleRefreshButton;
